import { isServer } from '../utils/is-server';
import {
  AppConfig,
  getPublicRuntimeConfig,
} from '../utils/public-runtime-config';

export default function getAppConfig(): AppConfig {
  if (isServer()) {
    return getPublicRuntimeConfig();
  }
  return window.Hippo.config;
}
